import React, { useState } from 'react';
import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import 'startbootstrap-sb-admin-2/css/sb-admin-2.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '../../styles/admin-custom.css';
import NotificationDropdown from './NotificationDropdown';

const OrganizerLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarToggled, setSidebarToggled] = useState(true);

  const handleLogout = async () => {
    await logout();
    navigate('/organizer/login');
  };

  return (
    <div id="wrapper" className="organizer-layout">
      {/* Sidebar */}
      <ul className={`navbar-nav bg-gradient-primary sidebar sidebar-dark accordion ${sidebarToggled ? 'toggled' : ''}`} id="accordionSidebar">
        
        {/* Sidebar - Brand */}
        <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/organizer/dashboard">
          <div className="sidebar-brand-icon rotate-n-15">
            <i className="fas fa-calendar-check"></i>
          </div>
          <div className="sidebar-brand-text mx-3">Organizer Panel</div>
        </Link>

        {/* Divider */}
        <hr className="sidebar-divider my-0" />

        {/* Nav Item - Dashboard */}
        <li className={`nav-item ${location.pathname === '/organizer/dashboard' ? 'active' : ''}`}>
          <Link className="nav-link" to="/organizer/dashboard" data-title="Dashboard">
            <i className="fas fa-fw fa-tachometer-alt"></i>
            <span>Dashboard</span>
          </Link>
        </li>

        {/* Divider */}
        <hr className="sidebar-divider" />

        {/* Heading */}
        <div className="sidebar-heading">
          Management
        </div>

        {/* Nav Item - Events */}
        <li className={`nav-item ${location.pathname === '/organizer/events' ? 'active' : ''}`}>
          <Link className="nav-link" to="/organizer/events" data-title="Events">
            <i className="fas fa-fw fa-calendar"></i>
            <span>Events</span>
          </Link>
        </li>

        {/* Nav Item - Orders */}
        <li className={`nav-item ${location.pathname === '/organizer/orders' ? 'active' : ''}`}>
          <Link className="nav-link" to="/organizer/orders" data-title="Orders">
            <i className="fas fa-fw fa-shopping-cart"></i>
            <span>Orders</span>
          </Link>
        </li>

        {/* Nav Item - Tickets */}
        <li className={`nav-item ${location.pathname === '/organizer/tickets' ? 'active' : ''}`}>
          <Link className="nav-link" to="/organizer/tickets" data-title="Tickets">
            <i className="fas fa-fw fa-ticket-alt"></i>
            <span>Tickets</span>
          </Link>
        </li>

        {/* Nav Item - Agents */}
        <li className={`nav-item ${location.pathname === '/organizer/agents' ? 'active' : ''}`}>
          <Link className="nav-link" to="/organizer/agents" data-title="Agents">
            <i className="fas fa-fw fa-users"></i>
            <span>Agents</span>
          </Link>
        </li>

        {/* Nav Item - Financial Reports */}
        <li className={`nav-item ${location.pathname === '/organizer/financial' ? 'active' : ''}`}>
          <Link className="nav-link" to="/organizer/financial" data-title="Financial Reports">
            <i className="fas fa-fw fa-dollar-sign"></i>
            <span>Financial Reports</span>
          </Link>
        </li>

        {/* Divider */}
        <hr className="sidebar-divider" />

        {/* Heading */}
        <div className="sidebar-heading">
          Account
        </div>

        {/* Nav Item - Settings */}
        <li className={`nav-item ${location.pathname === '/organizer/settings' ? 'active' : ''}`}>
          <Link className="nav-link" to="/organizer/settings" data-title="Settings">
            <i className="fas fa-fw fa-cog"></i>
            <span>Settings</span>
          </Link>
        </li>

        {/* Divider */}
        <hr className="sidebar-divider d-none d-md-block" />

        {/* Sidebar Toggler */}
        <div className="text-center d-none d-md-inline">
          <button 
            className="rounded-circle border-0" 
            id="sidebarToggle"
            onClick={() => setSidebarToggled(!sidebarToggled)}
          ></button>
        </div>

      </ul>
      {/* End of Sidebar */}

      {/* Content Wrapper */}
      <div id="content-wrapper" className="d-flex flex-column">

        {/* Main Content */}
        <div id="content">

          {/* Topbar */}
          <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

            {/* Sidebar Toggle (Topbar) */}
            <button 
              id="sidebarToggleTop" 
              className="btn btn-link d-md-none rounded-circle mr-3"
              onClick={() => setSidebarToggled(!sidebarToggled)}
            >
              <i className="fa fa-bars"></i>
            </button>

            {/* Topbar Navbar */}
            <ul className="navbar-nav ml-auto">

              {/* Notifications */}
              {/*<NotificationDropdown userType="organizer" />*/}

                <button className="" onClick={handleLogout}>
                    <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                    Logout
                </button>

                <div className="topbar-divider d-none d-sm-block"></div>

              {/* Return to Admin (if impersonating) */}
              {localStorage.getItem('admin_impersonating') === 'true' && (
                <li className="nav-item">
                  <button
                    className="btn btn-sm btn-warning mr-3"
                    style={{ marginTop: '8px' }}
                    onClick={() => {
                      const adminToken = localStorage.getItem('admin_return_token');
                      const adminUser = localStorage.getItem('admin_return_user');
                      
                      if (adminToken && adminUser) {
                        // Restore admin session
                        localStorage.setItem('token', adminToken);
                        localStorage.setItem('user', adminUser);
                        localStorage.setItem('userRole', 'admin');
                        
                        // Clean up impersonation data
                        localStorage.removeItem('admin_impersonating');
                        localStorage.removeItem('admin_return_token');
                        localStorage.removeItem('admin_return_user');
                        
                        // Redirect to admin dashboard
                        window.location.href = '/admin/dashboard';
                      }
                    }}
                    title="Return to Admin Dashboard"
                  >
                    <i className="fas fa-arrow-left mr-1"></i>
                    Return to Admin
                  </button>
                </li>
              )}

              {/* Nav Item - User Information */}
              <li className="nav-item dropdown no-arrow">
                <a className="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <span className="mr-2 d-none d-lg-inline text-gray-600 small">{user?.name}</span>
                  <i className="fas fa-user-circle fa-2x text-gray-400" style={{cursor: 'pointer'}} onClick={(e) => { e.stopPropagation(); navigate('/organizer/profile'); }}></i>
                </a>
                {/* Dropdown - User Information */}
                <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">
                  <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); navigate('/organizer/profile'); }}>
                    <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                    Profile
                  </a>
                  <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); navigate('/organizer/settings'); }}>
                    <i className="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400"></i>
                    Settings
                  </a>
                  <div className="dropdown-divider"></div>
                  <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); handleLogout(); }}>
                    <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                    Logout
                  </a>
                </div>
              </li>

            </ul>

          </nav>
          {/* End of Topbar */}

          {/* Begin Page Content */}
          <div className="container-fluid">
            <Outlet />
          </div>
          {/* End of Page Content */}

        </div>
        {/* End of Main Content */}

        {/* Footer */}
        <footer className="sticky-footer bg-white">
          <div className="container my-auto">
            <div className="copyright text-center my-auto">
              <span>Copyright &copy; Ticketaty {new Date().getFullYear()}</span>
            </div>
          </div>
        </footer>
        {/* End of Footer */}

      </div>
      {/* End of Content Wrapper */}

    </div>
  );
};

export default OrganizerLayout;

